// remove animation when resizing the windows
let resizeTimer;
window.addEventListener("resize", () => {
  document.body.classList.add("resize-animation-stopper");
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.body.classList.remove("resize-animation-stopper");
  }, 400);
});

// dom selection for navigation
const primaryNav = document.querySelector(
  ".primary-navigation.mobile-navigation"
);
const navToggle = document.querySelector(".mobile-nav-toggle");
const body = document.querySelector("body");

navToggle.addEventListener("click", () => {
  const navVisible = primaryNav.getAttribute("data-visible");

  if (navVisible === "false" || navVisible === null) {
    primaryNav.setAttribute("data-visible", "true");
    navToggle.setAttribute("aria-expanded", "true");
    body.classList.add("modal-open");
  } else {
    primaryNav.setAttribute("data-visible", "false");
    navToggle.setAttribute("aria-expanded", "false");
    body.classList.remove("modal-open");
  }
});

// sticky header
window.addEventListener("scroll", function () {
  var header = document.querySelector("header");
  if (window.pageYOffset > 0) {
    header.classList.add("sticky-header");
    // document.body.style.paddingTop = header.offsetHeight + "px";
  } else {
    header.classList.remove("sticky-header");
    // document.body.style.paddingTop = "0";
  }
});

// hover effect on the nav bar
const dropdownContainers = document.querySelectorAll(".site-nav--has-dropdown");

if (window.innerWidth > 1024) {
  dropdownContainers.forEach(function (container) {
    const link = container.querySelector(".site-nav__link");
    const dropdown = container.querySelector(".site-nav__dropdown");

    container.addEventListener("mouseenter", function () {
      dropdown.style.display = "block";
      link.setAttribute("aria-expanded", "true");
      container.classList.add("opened");
    });

    container.addEventListener("mouseleave", function () {
      dropdown.style.display = "none";
      link.setAttribute("aria-expanded", "false");
      container.classList.remove("opened");
    });

    container.addEventListener("click", function (event) {
      // Stop the event propagation
      event.stopPropagation();
    });
  });
}

// adding plus and minus on cart page
document.addEventListener("DOMContentLoaded", function () {
  var quantityInputs = document.querySelectorAll(".quantity-input");

  quantityInputs.forEach(function (quantityInput) {
    var minusButton = quantityInput.querySelector(".minus-btn");
    var plusButton = quantityInput.querySelector(".plus-btn");
    var input = quantityInput.querySelector(".count");

    minusButton.addEventListener("click", function () {
      var currentValue = parseInt(input.value);
      if (currentValue > 0) {
        input.value = currentValue - 1;
      }
    });

    plusButton.addEventListener("click", function () {
      var currentValue = parseInt(input.value);
      input.value = currentValue + 1;
    });
  });
});
